const e = {
  name: "CocktailVodkalime",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32.3 40" style="enable-background:new 0 0 32.3 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,0l3,19h26.3L29,40H3.3L0,19h4L1.1,0.3L3,0z M2.3,21L3,25h2l-0.6-4H2.3z M10.7,27H7.3L9,38h18.3l1.7-11
			h-7.5l-8.9,8.9L12,35.2C9.8,33,9.4,29.6,10.7,27z M12.3,25c2.6-2.4,6.6-2.3,9.3,0h7.8l0.6-4H6.3L7,25H12.3z M3.3,27L5,38h2L5.3,27
			H3.3z M13.4,26.7c-1.7,1.7-1.9,4.4-0.6,6.3l6.9-6.9C17.7,24.8,15.1,25,13.4,26.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as CocktailVodkalime
};
